import React from 'react'
import PropTypes from 'prop-types'
import {
    Select,
    MenuItem,
    FormHelperText,
    FormControl
} from '@material-ui/core'

const BitrateSelect = ({ value, onChange }) => {
    return (
        <FormControl>
            <Select
                label="Bitrate"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                <MenuItem value={1.5}>Proxy (1.5mbps)</MenuItem>
                <MenuItem value={10}>Mezzanine (10mbps)</MenuItem>
                <MenuItem value={50}>Broadcast HD (50mbps)</MenuItem>
                <MenuItem value={100}>Broadcast HD (100mbps)</MenuItem>
                <MenuItem value={200}>Broadcast HD (200mbps)</MenuItem>
            </Select>
            <FormHelperText>Bitrate</FormHelperText>
        </FormControl>
    )
}

BitrateSelect.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
}

export default BitrateSelect
